// extracted by mini-css-extract-plugin
export default {"header":"MessageHeader_header__fn42E","headerText":"MessageHeader_headerText__+YH6B"};